import { Component, Input } from '@angular/core';

import { MyBetsBetSlip, MyBetsListContext } from '../../../my-bets-base/models/my-bets-viewmodels';
import { StakeInputModeStrategy, TypingStakeInputModeStrategy } from '../../../numpad/stake-input-mode.strategy';
import { MyBetsTrackingLocation } from '../../models/my-bets-tracking.model';

@Component({
    selector: 'ms-my-bets-list-column',
    templateUrl: 'my-bets-list-column.component.html',
    providers: [{ provide: StakeInputModeStrategy, useClass: TypingStakeInputModeStrategy }],
})
export class MyBetsListColumnComponent {
    @Input() betslips: MyBetsBetSlip[] = [];
    @Input() myBetsListContext: MyBetsListContext;
    @Input() hasDateSeparators: boolean;
    @Input() oneColumn: boolean;

    trackingLocation = MyBetsTrackingLocation;

    betslipTrackBy(index: number, betslip: MyBetsBetSlip): string {
        return betslip.betslipRealId;
    }
}
